// src/shared/utils/agendamentoHelpers.js

export const getEstadoLembrete = (agendamento) => {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  if (agendamento.status === "CONFIRMADO") {
    return {
      estado: "CONFIRMADO",
      cor: "#4caf50",
      mensagem: null,
    };
  }

  // Se já ligaram, está OK
  const chamadaFeita =
    agendamento.chamadas?.primeira || agendamento.chamadas?.segunda;
  if (chamadaFeita) {
    return { estado: "OK", cor: "#4caf50", mensagem: null };
  }

  // Se NÃO ligaram, verificar se alguma data de lembrete passou
  const lembretes = [
    { data: agendamento.dataLembrete1Dia, periodo: "1 dia" },
    { data: agendamento.dataLembrete1Semana, periodo: "1 semana" },
    { data: agendamento.dataLembrete1Mes, periodo: "1 mês" },
  ];

  for (const lembrete of lembretes) {
    if (!lembrete.data) continue; // Pula se não tem data definida

    const dataLembrete = new Date(lembrete.data);
    dataLembrete.setHours(0, 0, 0, 0);

    const diasPassados = Math.floor(
      (hoje - dataLembrete) / (1000 * 60 * 60 * 24)
    );

    if (diasPassados > 0) {
      return {
        estado: "ATRASADO",
        cor: "#f44336",
        mensagem: `Lembrete (${lembrete.periodo}) atrasado ${diasPassados} dia(s)`,
        diasPassados,
      };
    } else if (diasPassados === 0) {
      return {
        estado: "HOJE",
        cor: "#ff9800",
        mensagem: `Lembrete (${lembrete.periodo}) é HOJE`,
        diasPassados: 0,
      };
    }
  }

  return { estado: "FUTURO", cor: "#9e9e9e", mensagem: null };
};

export const contarLembretesPendentes = (agendamentos) => {
  let urgentes = 0;
  let hoje = 0;

  agendamentos.forEach((ag) => {
    // ✅ MODIFICAR: Só conta se não for CONFIRMADO
    if (ag.status !== "CONFIRMADO") {
      const estado = getEstadoLembrete(ag);
      if (estado.estado === "ATRASADO") urgentes++;
      if (estado.estado === "HOJE") hoje++;
    }
  });

  return { urgentes, hoje, total: urgentes + hoje };
};
